import React, {useEffect, useState} from "react";
import {ComponentHeader, MainContainer, SearchContainer} from "./styles";
import Button from "../../common/atoms/button";
import TableComponent from "../../common/components/TableComponent";
import Utility from "../../utility";
import referralService from "../../services/referralList";
import AddReferralUserModal from "../../components/AddReferralUserModal";
import ReferredUserListModal from "../../components/ReferredUserListModal";

const ReferralList = (props) => {
    const [isVisible, setVisible] = useState(false)
    const [ListVisible, setListVisible] = useState(false)
    const [referralList, setReferralList] = useState([])
    const [selectedReferral, setSelectedReferral] = useState(null);

    const fetchReferralUsers = async () => {
        let [err, referrals] = await Utility.parseResponse(referralService.getReferralList());
        if (!referrals || err)
            return Utility.apiFailureToast("Unable to fetch referralList");
        setReferralList(referrals)
    }

    useEffect(() => {
        fetchReferralUsers().then(() => 'Fetched')
    }, [])

    return (
        <>
            <AddReferralUserModal isVisible={isVisible} setVisible={setVisible}
                                  refreshList={fetchReferralUsers}/>

            <ReferredUserListModal isVisible={ListVisible} setVisible={setListVisible}
                                   id={selectedReferral}/>
            <MainContainer>
                <ComponentHeader>
                    <SearchContainer>
                        Referrals Promo
                    </SearchContainer>
                    <Button width='fit-content' onClick={() => setVisible(true)}>+ Add Referral User</Button>
                </ComponentHeader>
                <TableComponent.Table cellpadding="0" cellspacing="0">
                    <TableComponent.TableHead>
                        <TableComponent.HeadColumn>Referral code</TableComponent.HeadColumn>
                        <TableComponent.HeadColumn>Name</TableComponent.HeadColumn>
                        <TableComponent.HeadColumn>Offer Discount?</TableComponent.HeadColumn>
                        <TableComponent.HeadColumn>Referral count</TableComponent.HeadColumn>
                        <TableComponent.HeadColumn>Added On</TableComponent.HeadColumn>
                    </TableComponent.TableHead>
                    <TableComponent.TableBody>
                        {referralList?.map((item) => (
                            <TableComponent.BodyRow key={item._id} onClick={e => {
                                setSelectedReferral(item._id)
                                setListVisible(true)
                            }}>
                                <TableComponent.BodyColumn>{item.code}</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{item.name}</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{item.isDiscountedPromo ? "✅" : "❌"}</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{item.count || "-"}</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{new Date(item.addedOn).toDateString()}</TableComponent.BodyColumn>
                                {/*<TableComponent.BodyColumn>{item.isInactive ? "Inactive" : "Active"}</TableComponent.BodyColumn>*/}
                            </TableComponent.BodyRow>
                        ))}
                    </TableComponent.TableBody>
                </TableComponent.Table>

            </MainContainer>
        </>
    )
}
export default ReferralList;
